import { render, staticRenderFns } from "./currentPath.vue?vue&type=template&id=38d2b47c&scoped=true&"
import script from "./currentPath.vue?vue&type=script&lang=js&"
export * from "./currentPath.vue?vue&type=script&lang=js&"
import style0 from "./currentPath.vue?vue&type=style&index=0&id=38d2b47c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d2b47c",
  null
  
)

export default component.exports